export const helperText={
  loginPageText:{
      emptymemberCodeError: "Please enter the Member Code.",
      emptyPasswordError: "Please enter the Password.",
      emptySurNameError: "Please enter the Username.",
      emptyCaptcha: "Captcha does not match.",
      wrongLoginDetails:"Please check your username and password.",
      emptyUserCodeError:"Please enter the User Code.",
      errorEmailAddress: "Please enter your registered Primary Email Address.",
      inValidEmailAddress: "Incorrect Email format entered.",
      mailSentSuccessfully:"Email to reset the password has been sent out to your registered email address.",
      emailNotRegistered:"Please enter the registered Primary Email Address.",
      wrongGradeSelected: "Please select the correct grade."
  },
  registerPageText:{
    emptyUserName:"Please enter the Name.",
    emptyDob : "Please select the Date of Birth.",
    emptyNationality : "Please enter the Nationality.",
    emptypassportNumber : "Please enter the Passport Number.",
    emptyPassportIssueDate : "Please select the Date of Issue.",
    emptyCDCNumber : "Please enter the CDC Number.",
    emptyCDCIssueDate : "Please select the Date of Issue.",
    emptyCDCIssuePlace : "Please enter the Place of Issue.",
    emptyAddress : "Please enter the Address.",
    emptyCountry : "Please enter the Country.",
    emptyMobileNumber : "Please enter the Mobile number.",
    emptyEmail : "Please enter the Email address.",
    emptyContactAddress : "Please enter the Contact address.",
    emptyTrainingInstituteName : "Please enter the Training Institute Name.",
    emptyTrainingCourse : "Please enter the Training Course.",
    emptyTrainingInstituteAddress : "Please enter the Training Institute Address.",
    emptyJoiningDate : "Please select the Joining Date.",
    emptyCourseCompletionDate : "Please select the Course Completion Date.",
    emptyForCollection : "Please select the For Collection option.",
    emptyForPayment : "Please select the For Payment option.",
    emptyCaptcha : "Please enter the Captcha.",
    wrongCaptcha : "Captcha does not match.",
  },
  resetPageText:{
    emptyPassword:"Your password cannot be empty.",
    specialCharacterMissing:"Your password should contain atleast one special character.",
    unMatchPassword:"Your password does not match.",
    passwordLength:"Your password length should be of minimum 8 characters.",
    passwordUpdateSuccess:"Your Password has been updated.",
    urlAlreadyUsed:"This Url has already been used to change the Password please send a new URL to your email address."
  },
  memberRegistration:{
    emptymemberNumber:"Please enter the Member Number.",
    zeromemberNumber:"Member number cannot be 0.",
    emptySerialNumber:"Please enter the Serial Number.",
    zeroSerialNumber:"Serial number cannot be 0.",
    emptyFirstName:"Please enter the First Name.",
    emptySurname:"Please enter the Surname.",
    emptyBranch:"Please enter the Branch.",
    wrongEmail:"Please enter proper email address.",
    emptyhouseNumber:"Please enter the House No./Building.",
    emptyArea:"Please enter the Area/ Locality.",
    emptyVillage:"Please enter the Village/ Town/ City.",
    emptyPincode:"Please enter the Pincode.",
    emptyPassword:"Please enter the Password.",
  },
  shipBoardDetails:{
    emptyShipName:"Please enter a ship name.",
    emptyIMONo:"Please enter a IMO Number.",
    emptyJoiningDate:"Please select a joining date",
    emptyLeavingDate:"Please select a leaving date",
  },
  profilePage:{
    emptyMailMessage:"Please enter the change request message.",
  }
}